const oldPortalUrl = 'https://mars-bdf.fieldassist.io/';
const dashboardAPIUrl = 'https://fadashboardv2-bdf.azurewebsites.net/';
//const dashboardAPIUrl = 'https://localhost:5001/';


export {
    oldPortalUrl,
    dashboardAPIUrl,
}